import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import HeaderSignupCollection from './HeaderSignupCollection';
import ProposeMyHome from './ProposeMyHome';

const SignupFunnelCollection = () => (
    <Router>
        <Routes>
            <Route
                path="/:locale?/collection/propose-my-home"
                element={
                    <>
                        <HeaderSignupCollection />
                        <ProposeMyHome />
                    </>
                }
            />
            <Route path="/:locale?/collection/propose-my-home/*" element={<HeaderSignupCollection />} />
        </Routes>
    </Router>
);

export default SignupFunnelCollection;
